import React, { useRef } from "react";
import { FaMedal } from "react-icons/fa";
import Typewriter from 'typewriter-effect';
import ImageAbout from '../assets/pexels-amirali-beigi-792326.jpg'
import ContactShort from '../components/HomePageComponents/ContactShort'
import { useScroll, useTransform,motion } from "framer-motion";
import styles from './About/style.module.scss';

function AboutPage() {

    const container = useRef(null);
    const { scrollYProgress } = useScroll({
      target: container,
      offset: ["start end", "end start"],
    });
  
    const x1 = useTransform(scrollYProgress, [0, 1], [0, 150]);
    const x2 = useTransform(scrollYProgress, [0, 1], [0, -150]);
    const height = useTransform(scrollYProgress, [0, 0.9], [50, 0]);


    return (
      <div className="">
          <div ref={container} className={styles.slidingImages}>
  <div className="mt-20  lg:mx12 bg-[#] text-[#1C1D20] z-1 lg:px-24" >
  <h1 className=" text-2xl font-bold mx-auto text-black  a_text">
                I'm
a
freelance
designer
and
<span className="text-[#455ce9]"> began
my
career
in
web
and
full-stack
development
in
2020.</span>
I
later
transitioned
into
the
design
field,
driven
by
a
passion
for
web
design,
web application,
branding,
and
mobile
application
projects.
                </h1>
            </div> 
            <div className="flex px-12  pb-24 md:flex-row flex-col mt-10 justify-start items-center md:mt-0 text-center gap-20 lg:gap-52" >
                <div className="md:w-1/5  h-96 w-96 md:-mt- grid grid-cols-2 gap-6" >
                    <img
                        src='https://i.ibb.co/JQG0z5X/about-programming.jpg'
                        // className="rounded-bl-full rounded-tr-full box md:w-2/3   "
                        alt=""
                        className="w-28 h-46"
                    />
                    <img
                        src='https://i.ibb.co/WWKN4NS/about-reading-books.jpg'
                        // className="rounded-bl-full rounded-tr-full box md:w-2/3   "
                        alt=""
                        className="w-28 h-46"
                    />
                    <img
                        src='https://i.ibb.co/wKrdZnG/430888.jpg'
                        // className="rounded-bl-full rounded-tr-full box md:w-2/3   "
                        alt=""
                        className="w-[260px] h-[160px]"
                    />
                </div>
                <div className="md:w-1/2 md:text-start " >
                    <h1 className="text-5xl w-full mx-auto text-black mb-5">About Me</h1>

                    <div className="text-[#141517]"> 
                        <p className="a-b text-[#141517]">
                         
                            


                            I was born and raised in a small town in Bangladesh called Barishal. When I enrolled in college in 2019 at the age of 16, I wasn’t sure what I wanted to do with my life. Initially, I thought my profession would be related to the civil engineer. And Before delving into the world of web development and design, I also worked as a waiter.


                        </p>
                        <div className="a-b-p"> As a junior web developer I realized that I enjoyed the creative aspect of my work more, and I made a full transition into the field of design. Since then, I have worked as a freelancer on platforms like upwork/Fiverr and collaborated with companies and clients on a full-time or contract basis. I’ve worked with prominent companies and clients.
</div>
                    </div>

                    
                </div>

            <motion.div style={{ height }} className={styles.circleContainer}>
        <div className={styles.circle}></div>
      </motion.div>
        </div>
            
        </div>
        <ContactShort/>
      </div>
      
    );
}



export default AboutPage;
